// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"about_mainContainer__36UP5","description":"about_description__3CfSf","second":"about_second__3Fo4h"};